export const LIST_HEIGHT = 208;
export const LIST_SIZE = 40;
